/**
 * @file sessionAnnotationsInitialQuery.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Feb 07, 2023 10:58
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    sessionAnnotationsDialogSet,
} from 'src/store/actions/sessionAnnotations/sessionAnnotationsPages.actions';

import {
    SESSION_ANNOTATIONS_INITIAL_QUERY_REQUEST,
    sessionAnnotationsInitialQuerySuccess,
    sessionAnnotationsInitialQueryFailure,
} from 'src/store/actions/sessionAnnotations/sessionAnnotationsDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/sessionAnnotations/initialQuery';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            annotatorId: payload.annotatorId,
            docId: payload.docId,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* createRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(sessionAnnotationsInitialQuerySuccess(resp.payload));

        // open the dialog
        yield put(sessionAnnotationsDialogSet(true));

    } catch (error) {
        yield put(sessionAnnotationsInitialQueryFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* createRequestMonitor() {
    yield takeLatest(SESSION_ANNOTATIONS_INITIAL_QUERY_REQUEST, createRequestSaga);
}
